import React from 'react';
import {LaConFetch} from 'components/Functions/fetch';
import NotificationItem from './NotificationItem';
import CustomScrollbars from 'util/CustomScrollbars';
import moment from 'moment';

const defWarn = {
  text: 'Não há nenhuma notificação',
  time: moment().format('hh:mm'),
}

class AppNotification extends React.Component{
  constructor(props){
    super(props)
    this.state = {
      loaded: false,
      warns: [],
    }
    LaConFetch(`api/newsR`,
    (result)=>{
      if(result.news.length > 0){
        this.props.feedback(true);
        this.setState({
          warns: result.news,
          loaded: true,
        });
    }else{
      this.props.feedback(false);
    }
    },(error)=>{})
  }
  render(){
    const {loaded,warns} = this.state;

    return (
      <CustomScrollbars className="messages-list scrollbar" style={{height: 140}}>
        <ul className="list-unstyled">
          {loaded && warns.length > 0 ? (
            warns.map((item,index)=>{return(<NotificationItem key={index} notification={item}/>)})
          ):(
            <NotificationItem key={1} notification={defWarn}/>
          )
          }
        </ul>
      </CustomScrollbars>
    )
  }
};

export default AppNotification;

